import $ from 'jquery';
import ShopifySurfacePickUp from '@pixelunion/shopify-surface-pick-up';

import Modal from '../components/Modal';
import ProductGallery from '../components/ProductGallery';
import VariantHelper from '../utils/VariantHelper';
import ThemeUtils from '../utils/ThemeUtils';
import PaymentTerms from '../helpers/PaymentTerms';

export default class Product {
  constructor(section) {
    this.$el = $(section.el);
    this.el = section.el;

    this.data = section.data;

    this.variantHelpers = null;

    this.$productForm = $('[data-product-form]', this.$el);
    this.formID = this.$productForm.attr('data-product-form');

    // Form selectors
    this.productForm = `product-form-${this.formID}`;
    this.$addToCartButton = $('.add-to-cart input', this.$el);
    this.$priceArea = $('.product-price', this.$el);
    this.$productMessage = $('[data-product-message]', this.$el);

    // Gallery
    const gallery = this.el.querySelector('[data-product-gallery]');

    if (gallery) {
      this.productGallery = new ProductGallery(
        gallery,
        {
          enable_video_autoplay: this.data.settings.gallery_enable_video_autoplay,
          enable_video_looping: this.data.settings.gallery_enable_video_looping,
          enable_zoom: this.data.settings.gallery_enable_zoom,
        },
      );
    }

    // Setup product information
    const $productJSON = $(`[data-product-json-${this.formID}]`, this.$el);
    const $productSettings = $(`[data-product-settings-${this.formID}]`, this.$el);

    if (!$productJSON.length) { return; }

    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    this.$variantDropdowns = $(`[data-option-select=${this.formID}]`, this.$el);
    this.$variantRadio = $(`[data-option-input=${this.formID}]`, this.$el);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;
    this.processing = false;

    this.paymentTerms = new PaymentTerms(this.el);

    this.setupVariants();
    this._bindEvents();

    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  _bindEvents() {
    this.$addToCartButton.on('click', event => this.addToCart(event));
  }

  setupVariants() {
    this.surfacePickUp = new ShopifySurfacePickUp(this.el.querySelector('[data-surface-pick-up]'));

    const variantHelperDefaults = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: $('[data-product-gallery-thumbnail]', this.el),
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      onVariantChange: variant => this._onVariantChangeCallback(variant),
      enableHistory: this.data.enable_history,
    };

    if (this.$variantDropdowns.length) {
      let dropdownSettings = {
        $selector: this.$variantDropdowns,
        type: 'select',
      };

      dropdownSettings = ThemeUtils.extend(variantHelperDefaults, dropdownSettings);

      this.variantHelpers = new VariantHelper(dropdownSettings);
      this.$variantDropdowns.trigger('change');
    }

    if (this.$variantRadio.length) {
      let radioSettings = {
        $selector: this.$variantRadio,
        type: 'radio',
      };

      radioSettings = ThemeUtils.extend(variantHelperDefaults, radioSettings);

      this.variantHelpers = new VariantHelper(radioSettings);
      this.$variantRadio.trigger('change');
    }

    const selectedVariant = () => (this.variantHelpers
      ? this.variantHelpers.getSelectedVariant()
      : this.productJSON.variants[0]); // product has only default variant

    this.surfacePickUp.load(selectedVariant().id);
    this.surfacePickUp.onModalRequest(content => {
      const variantTitle = this.variantHelpers
        ? `<div class="modal__surface-pick-up-variant">${selectedVariant().title}</div>`
        : '';

      const header = `
          <h2 class="modal__surface-pick-up-title">${this.productJSON.title}</h2>
          ${variantTitle}
        `;

      Modal.open({ header, content });
    });
  }

  _onVariantChangeCallback(variant) {
    if (variant) {
      this.surfacePickUp.load(variant.id);
      this.paymentTerms.update(variant.id);
    } else {
      this.el.querySelector('[data-surface-pick-up]').innerHTML = '';
    }
  }

  addToCart(e) {
    if (this.productSettings.cartRedirect) { return; }

    e.preventDefault();

    if (this.processing) { return; }
    this.processing = true;

    if (Modernizr.cssanimations) {
      $('.add-to-cart', this.$el).addClass('loading');
    } else {
      this.$addToCartButton.val(this.productSettings.processingText);
    }

    const quantity = $('input[name="quantity"]', this.$el).val();

    if ((quantity === '') || (quantity === '0')) {
      setTimeout(() => {
        $('input[name="quantity"]', this.$el)
          .addClass('error');
        this.$productMessage
          .removeClass('success')
          .addClass('error')
          .text(this.productSettings.setQuantityText);
        $('.add-to-cart', this.$el)
          .removeClass('loading');

        this.processing = false;
      },
      500);
    }

    Shopify.addItemFromForm(this.productForm, cartItem => setTimeout(() => {
      Shopify.getCart(cart => {
        document.dispatchEvent(new CustomEvent('cart:count', { detail: { count: cart.item_count } }));
      });

      const successMessage = this.productSettings.successMessage.replace('** product **', cartItem.title);

      $('input[name="quantity"]', this.$el)
        .removeClass('error');
      $('.add-to-cart', this.$el)
        .removeClass('loading');
      this.$productMessage
        .removeClass('error')
        .addClass('success')
        .html(successMessage);

      if (!Modernizr.cssanimations) {
        this.$addToCartButton.val(this.productSettings.addToCartText);
      }

      this.processing = false;
    },
    1000));
  }

  handleErrors(errors) {
    const errorMessage = $.parseJSON(errors.responseText);
    const productTitle = this.productJSON.title;

    let errorDescription = errorMessage.description;
    if (errorMessage.description.indexOf(productTitle) > -1) {
      errorDescription = errorDescription
        .replace(productTitle, `<em>${productTitle}</em>`);
    }

    if (errorMessage.message === 'Cart Error') {
      setTimeout(() => {
        $('input[name="quantity"]', this.$el).removeClass('error');
        this.$productMessage
          .removeClass('success')
          .addClass('error')
          .html(errorDescription);
        $('.add-to-cart', this.$el)
          .removeClass('loading added-success')
          .addClass('added-error');

        if (!Modernizr.cssanimations) {
          this.$addToCartButton.val(this.productSettings.addToCartText);
        }

        this.processing = false;
      },
      1000);
    }
  }

  onSectionUnload() {
    if (this.variantHelpers != null) {
      this.variantHelpers.prepareRemove();
    }

    if (this.ImageZoom != null) {
      this.ImageZoom.prepareRemove();
    }

    if (this.productGallery) {
      this.productGallery.unload();
    }

    $('.product-form', this.$el).off('submit');
  }
}
